import React, { useState, useRef, useEffect } from 'react';

const SortProducts = ({ onSortChange, currentSort = 'default' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const sortOptions = [
        { value: 'default', label: 'ברירת מחדל' },
        { value: 'name', label: 'שם המוצר' },
        { value: 'price', label: 'מחיר המוצר' },
        { value: 'sale', label: 'מוצרים במבצע' }
    ];

    const currentLabel = sortOptions.find(opt => opt.value === currentSort)?.label || 'ברירת מחדל';

    const handleSelect = (value) => {
        if (onSortChange) {
            onSortChange(value);
        }
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className="d-flex align-items-center gap-2 mb-2" ref={dropdownRef}>
            <div className="sort-label">מיין לפי:</div>
            <div className="custom-dropdown position-relative">
                <div 
                    className={`dropdown-trigger ${isOpen ? 'open' : ''}`}
                    onClick={() => setIsOpen(!isOpen)}
                    style={{ cursor: 'pointer' }}
                >
                    {currentLabel}
                    <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
                </div>
                <div 
                    className={`dropdown-menu-custom ${isOpen ? 'open' : ''}`}
                >
                    <ul className="list-unstyled mb-0 p-0">
                        {sortOptions.map(option => (
                            <li 
                                key={option.value}
                                className={`dropdown-item-custom ${currentSort === option.value ? 'active' : ''}`}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default SortProducts;
